import React from "react";
import "./index.less";
import HoverIcon from "@components/HoverIcon";
import {Input, Select, Table, Button, Form, Spin, DatePicker} from "antd";
import dayjs from "dayjs";
import CancelRecordService from "@services/CancelRecordService";
import {Link} from "react-router-dom";
import CommonBreadcrumb from "@components/CommonBreadcrumb";
import Lang from "@components/Lang/Lang";

const {RangePicker} = DatePicker;
const {Option} = Select;
const {Column} = Table;

class CancelRecord extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            list: [],
            pagination: {
                // 分页的
                pageSize: 50,
                total: 0,
                pageNum: 1
            }
        };
        this.filterForm = React.createRef();
        this.getList();
    }

    /**
     * 登记记录（查询）
     *
     * @param {Object} options 查询参数
     */
    getList(options) {
        CancelRecordService.queryList(options).then(resp => {
            let data = resp.data;
            if (data.success && data.valid) {
                this.setState({
                    list: data.models
                });
            }
        });
    }

    /**
     * 去搜索*/
    handleSearch() {
        let options = this.filterForm.current.getFieldsValue();
        // 登记时间
        if (options.registerTime) {
            options.registerBeginTime = options.registerTime[0].unix() * 1000;
            options.registerEndTime = options.registerTime[1].unix() * 1000;
            delete options.registerTime;
        }
        this.getList(options);
    }

    /**
     * 分页相关改变的触发*/
    onChange(pagination, filters, sorter, extra) {
        this.setState(
            {
                pagination: {
                    ...this.state.pagination,
                    pageNum: pagination.current,
                    pageSize: pagination.pageSize
                }
            },
            () => {
                this.getList();
            }
        );
    }

    render() {
        const {loading} = this.state;
        return (
            <div>
                {/* 面包屑 */}
                <CommonBreadcrumb list={[{name: Lang({id: "KeHuQuXiaoDengJi", default: "客户取消登记"})}]}/>
                <div className="cancel-record">

                    <div className="mb_26" data-flex="cross:center">
                        <p className="font-title fw_500 font_15 mr_10">{__getServerLanguage("KeHuQuXiaoDengJi")}</p>
                        <div className="font-main cursor-p">
                            <Link to={`/order/cancelRecord/AddNew`} data-flex="cross:center">
                                <p className="add-icon mr_6" data-flex="cross:center main:center">+</p>
                                <span className="font_14">{__getServerLanguage("XinZengDengJi")}</span>
                            </Link>
                        </div>
                    </div>

                    <div className="filter-box">
                        <Form className="input-form mb_16" ref={this.filterForm} layout="inline">
                            <Form.Item label={__getServerLanguage("DengJiShiJian")} name="registerTime">
                                <RangePicker showTime/>
                            </Form.Item>

                            <Form.Item>
                                <Input.Group compact={true}>
                                    <Form.Item name="searchParamStatusOne" initialValue={0}>
                                        <Select>
                                            <Option value={0}>{__getServerLanguage("DingDanDanHao")}</Option>
                                            <Option value={1}>{__getServerLanguage("DengJiDanHao")}</Option>
                                        </Select>
                                    </Form.Item>
                                    <Form.Item name="searchParamOne">
                                        <Input style={{width: "204"}} placeholder={__getServerLanguage("QingShuRu")}/>
                                    </Form.Item>
                                </Input.Group>
                            </Form.Item>

                            <Form.Item>
                                <Input.Group compact={true}>
                                    <Form.Item name="searchParamStatusTwo" initialValue={0}>
                                        <Select name="searchParamStatusTwo">
                                            <Option value={0}>{__getServerLanguage("KeHuBianMa")}</Option>
                                            <Option value={1}>{__getServerLanguage("CaoZuoRen")}</Option>
                                        </Select>
                                    </Form.Item>
                                    <Form.Item name="searchParamTwo">
                                        <Input style={{width: "204"}} placeholder={__getServerLanguage("QingShuRu")}/>
                                    </Form.Item>
                                </Input.Group>
                            </Form.Item>

                            <Form.Item>
                                <Button type="text" onClick={this.handleSearch.bind(this)}>
                                    {__getServerLanguage("SouSuo")}
                                </Button>
                            </Form.Item>
                        </Form>
                    </div>

                    <Spin spinning={loading}>
                        <Table
                            pagination={{
                                defaultPageSize: this.state.pagination.pageSize,
                                showQuickJumper: true,
                                total: this.state.pagination.total,
                                current: this.state.pagination.pageNum || 1,
                                showSizeChanger: true,
                                showTotal: total => `Total ${total} items`
                            }}
                            onChange={this.onChange.bind(this)}
                            dataSource={this.state.list}
                            rowKey="id"
                        >
                            <Column title={__getServerLanguage("KeHu")} key="buyerNumber" dataIndex="buyerNumber"/>
                            <Column title={__getServerLanguage("DengJiShiJian")} key="registerTime" dataIndex="registerTime" render={registerTime => <p>{registerTime ? dayjs(registerTime).format("YYYY-MM-DD") : "-"}</p>}/>
                            <Column title={__getServerLanguage("DanHao")} key="orderNumber" dataIndex="orderNumber"/>
                            <Column title={__getServerLanguage("GuanLianDanHao")} key="contactOrder" dataIndex="contactOrder"/>
                            <Column
                                title={__getServerLanguage("ShuLiang")}
                                key="ShuLiang"
                                render={(text, record) => (
                                    <p className="con1-txt fw_700">
                                        {record.skuNum}
                                        {__getServerLanguage("Kuan")}，{record.quantity}
                                        {__getServerLanguage("Xiang")}
                                    </p>
                                )}
                            />
                            <Column title={__getServerLanguage("CaoZuoRen")} key="currentUser" dataIndex="currentUser"/>
                            <Column
                                title={__getServerLanguage("CaoZuo")}
                                key="CaoZuo"
                                render={(text, record) => (
                                    <div data-flex="cross:center" className="">
                                        <div className="mr_8">
                                            <Link to={`/order/cancelRecord/details?id=${record.id}`}>
                                                <HoverIcon inactiveIcon="icon-xiangqing-moren-icon" activeIcon="icon-xiangqing-xuanzhong-icon"></HoverIcon>
                                            </Link>
                                        </div>
                                    </div>
                                )}
                            />
                        </Table>
                    </Spin>
                </div>
            </div>
        );
    }
}

CancelRecord.defaultProps = {};

export default CancelRecord;
